import React from 'react';
import {
  TableHeaderContainer,
  TableHeaderInputContainer,
  TableHeaderItems
} from './styles';

interface Props {
  title: string;
}

export const HeaderTableWrapper: React.FC<Props> = ({ title, children }) => {
  return (
    <TableHeaderContainer>
      <TableHeaderItems>
        <span>{title}</span>
      </TableHeaderItems>

      <TableHeaderInputContainer>{children}</TableHeaderInputContainer>
    </TableHeaderContainer>
  );
};
